<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-content class="ma-0">
    <div id="pgMainDI" :style="pgStyle">
      <!--
      <v-breadcrumbs :items="crumps" divider=">" class="hidden-sm-and-down pa-0 pl-2" color="blue" style="font-size: 11px!important;">
        <template v-slot:item="props">
          <a :href="props.item.href" :class="['v-breadcrumbs__item', props.item.disabled && 'disabled']"><span v-if="true">{{ props.item.text }}</span>
            <v-icon small color="#004884" v-if="props.item.icon">{{ props.item.icon}}</v-icon>
          </a>
        </template>
      </v-breadcrumbs>
      -->
      <router-view></router-view>
    </div>
  </v-content>
</template>

<script>
  import Vue from 'vue'
  import pgToolbar from './Toolbar.vue'
  import btnSupport from './widgets/BtnSupport'

  export default {
    name: 'DashItem.vue',
    components: {pgToolbar, btnSupport},
    data() {
      return {
        crumps: [],
        pgStyle: '',
        currentTitle: ''
      }
    },
    methods: {
      onClick: function () {
        window.history.back()
      },
      onGetBreadcrumb(data) {
        this.crumps = data
      },
      OnGetModuleTitle: function (title) {
        this.currentTitle = title
      },
      OnResize: function () {
        var footerHeight = $('#footerMenu').height()
        var view = Vue.prototype.$api.getViewport()
        var h2 = view.height - footerHeight - Vue.config.data.TABLE_SHRINK_HEIGHT - 96
        this.pgStyle = 'overflow-y: auto; height: ' + h2 + 'px'
      }
    },
    created() {
      Vue.prototype.$eventHub.$on('OnGetModuleTitle', this.OnGetModuleTitle)
      Vue.prototype.$eventHub.$on('OnGetBreadcrumb', this.onGetBreadcrumb)
      Vue.prototype.$eventHub.$on('OnResize', this.OnResize)
    },
    destroyed() {
      Vue.prototype.$eventHub.$off('OnGetBreadcrumb', this.onGetBreadcrumb)
      Vue.prototype.$eventHub.$off('OnGetModuleTitle', this.OnGetModuleTitle)
      Vue.prototype.$eventHub.$off('OnResize', this.OnResize)
    },
    mounted() {
      this.OnResize()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DashItem.vue